import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Table } from "antd";
import axios from "axios";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import SearchBox from "../../../../components/SearchBox";
import GradesModal from "../../../../components/modelpopup/DepartmentModal";
import { base_url } from "../../../../base_urls";
import {
  itemRender,
  pageSizeOptions,
  handlePageChange,
  defaultPagination
} from "utils/table";


import {getRequestApproverList} from "api/services/common"
import { useSearchParams } from 'react-router-dom';



const RequestApprover = () => {
  const [requestApproverData, setRequestApproverData] = useState([])
  const [requestApproverMapData, setRequestApproverMapData] = useState()
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})


const handleRowClick = (record) => {
  navigate(`/grades/${record.id}`); 
};


const handleChange = (pagination, filters, sorter) => {
  let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
  console.log(pageData)
  // setSearchParams({
  //     size: pageData?.pageSize,
  //     page: pageData?.page,
  //     sort_by: pageData?.sortBy || "",
  //     sort_type: pageData?.sortType || ""
  // })
  setPageSettings(pageData)
};


const toTitleCase = (str) => {
    return str
        .replace(/_/g, ' ') // Replace underscores with spaces
        .replace(/\b\w/g, char => char.toUpperCase()) // Capitalize each word
        .replace('Approver', 'Approver'); // Ensure 'Approver' remains unchanged
};


const getRequestApprover = () => {
  setLoading(true)

  // let _filters = [...filters].filter(item=> item.value)
  // const filter_params = _filters.reduce((acc, item) => {
  //     acc[item.key] = item.value;
  //     return acc;
  //   }, {});
  let filter_params = {}

    
  getRequestApproverList({
    sort_by:pageSettings?.sortBy,
    sort_type: pageSettings?.sortType,
    page_size: pageSettings?.pageSize,
    page: pageSettings?.page,
    ...filter_params

  }).then(response=>{
    console.log(response, "----resp")
    setRequestApproverData(response.data);
    setPageSettings({
      ...pageSettings,
      total: response.data.count
    })
    const responseData = response.data;

    const mappedData = Object.keys(responseData || {})
        .filter(key => key.includes('_approver') && responseData[key]?.user)
        .map((key, index) => ({
            id: index,
            title: toTitleCase(key), // Convert key to Title Case
            text: `${responseData[key].user.first_name} ${responseData[key].user.last_name}`,
            type: responseData[key].role,
           
        }));

    console.log(mappedData, "---MappedData")
    setRequestApproverMapData(mappedData)

    setLoading(false)
  }).catch(e=>{
    setLoading(false)
  })
}
useEffect(()=>{

    getRequestApprover()

},[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])



 const ListItem = ({ title, text,type }) => (
   <li>
     
     <div className="title">{title}</div>
     {(type=="mailto" || type=="tel") ? <a href={`${type}:${text}`} className="text">{text}</a> : <div className="text">{text}</div>  }
     
   </li>
 );




  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle="Settings"
            title="Settings"
            subtitle="Request Approver"
            modal="#request_approver"
            name="Request Approver"
          />
          {/* /Page Header */}
          <div className="row">
              <div className="col-md-6 d-flex">
                <div className="card profile-box flex-fill">
                <div className="card-body">
                    <h3 className="card-title">
                    Change Request Approver{" "}
                    
                    </h3>
                    <ul className="personal-info">
                    {requestApproverMapData && requestApproverMapData.map((item, index) => (
                        <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        text={item.text}
                        type={item.type}
                        />
                    ))}
                    </ul>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default RequestApprover;
